import { render, staticRenderFns } from "./VendorPhoneEmail.vue?vue&type=template&id=f3d2feda"
import script from "./VendorPhoneEmail.vue?vue&type=script&lang=js"
export * from "./VendorPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3d2feda')) {
      api.createRecord('f3d2feda', component.options)
    } else {
      api.reload('f3d2feda', component.options)
    }
    module.hot.accept("./VendorPhoneEmail.vue?vue&type=template&id=f3d2feda", function () {
      api.rerender('f3d2feda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorPhoneEmail.vue"
export default component.exports